// @flow
import DiamondCutTable from '@components/productDetail/DiamondCutTable';
import DiamondColorTable from '@components/productDetail/DiamondColorTable';
import DiamondClarityTable from '@components/productDetail/DiamondClarityTable';

import type { DiamondType } from '@types/diamond';

type PropsType = {
  diamond: DiamondType
};

export default ({diamond}: PropsType) => (
  [
    <DiamondCutTable cut={diamond.final_cut_grade} key='cut' />,
    <DiamondColorTable color={diamond.color} key='color' />,
    <DiamondClarityTable clarity={diamond.clarity} key='clarity' />
  ]
);
